export class PermisoModulos {
  idModulo?: number=-1;
  modulo?: number = 0;
  visualiza: number;
  agrega: number;
  actualiza: number;
  elimina: number;
  idUsuario: number;
  fechaHoraUM: string;
  estatus: number;
  detalle: number;
  recupera: number;
  moduloString?:string ="";
  nombre?:string = "";
  descripcionModulo?:string ="";
}
